import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/root/app/App';
import * as serviceWorker from './serviceWorker';
import './assets/css/style.css';
import './assets/css/animate.css';
import './assets/css/carousel.css';
import './assets/css/promperu_styles.css';


let search = window.location.search;
let params = new URLSearchParams(search);

var InitialData;

if (params.get('nBoletinCodigo')===null) {}

if (params.get('sUsuEmail')===null || params.get('sUsuNombre')===null || params.get('nUsuCodigo')===null)
{
    InitialData = {nBoletinCodigo: params.get('nBoletinCodigo'), nRecursoCodigo: 0, sUsuEmail: 'Sin email', nUsuCodigo: 0, sUsuNombre: 'Invitado', sUsuApellidoPaterno: 'Invitado' };
} else 
{
    InitialData = {nBoletinCodigo: params.get('nBoletinCodigo'), nRecursoCodigo: 0, sUsuEmail: params.get('sUsuEmail'), nUsuCodigo: params.get('nUsuCodigo'), sUsuNombre:params.get('sUsuNombre'), sUsuApellidoPaterno:params.get('sUsuApellidoPaterno') };
}

localStorage.setItem("userBulletin", JSON.stringify(InitialData));

// console.log('1. index.js')
// console.log('------------')
// console.log(InitialData);

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();
    